import { Build } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { MonetaryAmountSummaryStatistics } from '../modules/generated/api';

import IconValue from './IconValue';
import PackageDetailMinMaxRows from './PackageDetailMinMaxRows';
import UnitValue from './UnitValue';

type PackageDetailTileDamageProps = {
  priceDamage?: MonetaryAmountSummaryStatistics;
};

const PackageDetailTileDamage = ({ priceDamage }: PackageDetailTileDamageProps) => {
  const { t } = useTranslation();
  return (
    <IconValue icon={Build} label={t('car.damage')} padding>
      <PackageDetailMinMaxRows
        min={<UnitValue value={priceDamage?.min?.amount} unit={priceDamage?.min?.currency} />}
        avg={<UnitValue value={priceDamage?.avg?.amount} unit={priceDamage?.avg?.currency} />}
        max={<UnitValue value={priceDamage?.max?.amount} unit={priceDamage?.max?.currency} />}
      />
    </IconValue>
  );
};

export default PackageDetailTileDamage;
